import { Wrench, PackageSearch, Car, Briefcase, Store, Ship } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";
import { useSettings, mediaUrl } from "@/context/SettingsContext";

const ICONS = [Wrench, PackageSearch, Car, Briefcase, Store, Ship];

const Activities = () => {
  const { t } = useLanguage();
  const { settings } = useSettings();
  const imgs = settings.content?.activity_images || [];
  const items = t.activities.items.map((a, i) => ({ ...a, ...(settings.content?.activities?.[i] || {}) }));
  return (
    <section className="relative overflow-hidden bg-mint py-24 sm:py-32" data-testid="activities-section">
      <div className="dots-bg pointer-events-none absolute inset-0 opacity-60" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          overline={t.activities.overline}
          title={t.activities.title}
          accent={t.activities.titleAccent}
          sub={t.activities.sub}
        />

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((a, i) => {
            const Icon = ICONS[i];
            const orange = i % 2 === 1;
            return (
              <Reveal key={a.title} delay={i * 0.08}>
                <div
                  data-testid={`activity-card-${i}`}
                  className="group relative h-full overflow-hidden rounded-3xl border border-brand/10 bg-white transition-all duration-500 hover:-translate-y-1.5 hover:shadow-2xl hover:shadow-brand/10"
                >
                  {imgs[i] && (
                    <div className="aspect-[16/9] overflow-hidden" data-testid={`activity-image-${i}`}>
                      <img src={mediaUrl(imgs[i])} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                    </div>
                  )}
                  <div className="p-8">
                  <div
                    className={`absolute -right-10 -top-10 h-32 w-32 rounded-full opacity-10 transition-transform duration-700 group-hover:scale-[2] ${
                      orange ? "bg-gold" : "bg-brand"
                    }`}
                  />
                  <div className="relative">
                    <div className="flex items-center justify-between">
                      <span
                        className={`flex h-14 w-14 items-center justify-center rounded-2xl text-white ${
                          orange ? "bg-gold" : "bg-brand"
                        }`}
                      >
                        <Icon className="h-6 w-6" />
                      </span>
                      <span className="font-mono text-3xl font-light text-brand/30">0{i + 1}</span>
                    </div>
                    <h3 className="font-display mt-7 text-xl font-bold text-forest">{a.title}</h3>
                    <p className="mt-3 text-sm leading-relaxed text-brand-hover">{a.desc}</p>
                  </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Activities;
